<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='带教老师月度绩效计算' url='/achievement/monthly/teachlist'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.section" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考核月份：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.grantmonth" type="month" placeholder="考核月份" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">发放状态：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.grantstatus" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
        </div>
      </div>
      <!--end: Search Form -->
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Datatable -->
        <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
          <el-table-column prop="SectionName" label="管理单元">
          </el-table-column>
          <el-table-column label="月度">
            <template slot-scope="scope">
              {{scope.row.GrantMonth|formatDate}}
            </template>
          </el-table-column>
          <el-table-column label="凭证">
            <template slot-scope="scope">
              <div v-if="scope.row.GrantFile=='' || scope.row.GrantFile==null">
                <div style="float: left;width: 40px;height: 36px;line-height: 36px;">无</div>
                <div style="float: left;width: 75px;height: 36px;line-height: 36px;">
                  <el-upload class="upload-demo" ref="upload" :action='uploadUrl' :data="{id:scope.row.MGID}" :limit="1"
                    :on-success="handleAvatarSuccess" :show-file-list="false">
                    <a style="color:#66b1ff">[上传]</a>
                  </el-upload>
                </div>
              </div>
              <div v-if="scope.row.GrantFile!='' && scope.row.GrantFile!=null">
                <div style="float: left;width: 40px;height: 36px;line-height: 36px;">
                  <el-button @click="See(scope.row)" type="text" size="medium">查看</el-button>
                </div>
                <div style="float: left;width: 75px;height: 36px;line-height: 36px;">
                  <el-upload class="upload-demo" ref="upload" :action='uploadUrl' :data="{id:scope.row.MGID}"
                    :on-success="handleAvatarSuccess" :show-file-list="false">
                    <a style="color:#66b1ff">[重新上传]</a>
                  </el-upload>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发放状态">
            <template slot-scope="scope">
              <span v-bind:style="scope.row.GrantStatusName == '已发放'?'color:green;':'color:red;'">{{scope.row.GrantStatusName}}</span>
              <el-button @click="ChangeStatus(scope.row)" type="text" size="medium">[变更]</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="Info(scope.row)" type="text" size="medium">详细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--end: Datatable -->
        <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
            :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="condition.recordCount">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MonthlyTeachList',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          token: '',
          granttype: '2',
          cpimclass: '1',
          section: '',
          grantmonth: '',
          grantstatus: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        tableData: null,
        statusOptions: [{
          value: '1',
          label: '未发放'
        }, {
          value: '2',
          label: '已发放'
        }],
        searchUrl: this.$utils.Url.zpgl + '/api/APIMoneyGrant/TeachList',
        uploadUrl: this.$utils.Url.zpgl + '/api/APIMoneyGrant/UploadGrantFile',
        loading: true,
        managesecOptions: []
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      }
    },
    methods: {
      See: function(row) {
        var url = this.$utils.Url.zpgl + '/file/' + row.GrantFile
        window.open(url)
      },
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      handleAvatarSuccess: function(res) {
        if (res.Code === 0) {
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          this.$refs.upload.clearFiles()
          this.$refs.btnSearch.Search()
        } else {
          this.$message({
            message: res.Msg + '，' + res.Error,
            type: 'error'
          })
        }
      },
      Info: function(row) {
        this.$router.push({
          name: 'MonthlyTeach',
          params: {
            id: row.MGID
          }
        })
      },
      ChangeStatus: function(row) {
        var fd = this.$options.filters['formatDate']
        var GrantStatus = 1
        if (row.GrantStatus === 1) {
          GrantStatus = 2
        }
        var args = {
          id: row.MGID,
          grantstatus: GrantStatus,
          token: this.condition.token
        }
        this.$utils.Change(this.$utils.Url.zpgl + '/api/APIMoneyGrant/Update', args, '确定变更带教老师 ' + row.SectionName +
          ' ' + fd(row.GrantMonth) + ' 绩效奖金发放状态?', this.$refs.btnSearch.Search)
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.LoadManageSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
